import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	customizeSidebar: {
		id: 'navigation-apps-sidebar-nav4-sidebar-content.configurable-menu-items.sidebar-customization.customize-sidebar-menu-item.customize-sidebar',
		defaultMessage: 'Customize sidebar',
		description: 'Button text to open customization dialog',
	},
});
